import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  events: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  subEvents: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "event",
  initialState,
  reducers: {
    getEventsSuccess: (state, action) => {
      state.events = action.payload;
      state.loading = false;
    },
    startLoading: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getEvents = ({ accessToken, page, limit }) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
      dispatch(slice.actions.startLoading());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-events`,
        { headers }
      );
      dispatch(slice.actions.getEventsSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};
